import { createTheme } from '@mui/material/styles';
import { colors } from 'styles/colors';

export const osinTheme = createTheme({
  typography: {
    htmlFontSize: 17,
  },
  palette: {
    background: {
      default: colors.neutralVeryLight,
    },
    primary: {
      main: colors.primary,
      contrastText: '#fff',
    },
    secondary: {
      main: colors.secondary,
      contrastText: '#fff',
    },
    error: {
      main: colors.danger,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: colors.primary,
          color: '#fff',
          '--AppBar-color': '#fff',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '& .fas, & .far, & .fab': {
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: 1,
            verticalAlign: 'middle',
          },
          variants: [
            {
              props: { variant: 'outlined', color: 'primary' },
              style: {
                color: colors.defaultButton,
                borderColor: colors.defaultOutlinedButtonBorder,
                '--variant-outlinedColor': colors.defaultButton,
                '--variant-outlinedBorder': colors.defaultOutlinedButtonBorder,
              },
            },
            {
              props: { variant: 'outlined', color: 'secondary' },
              style: {
                color: colors.secondary,
                borderColor: colors.secondary,
                '--variant-outlinedColor': colors.secondary,
                '--variant-outlinedBorder': colors.secondary,
              },
            },
            {
              props: { variant: 'text', color: 'primary' },
              style: {
                color: colors.defaultButton,
                '--variant-textColor': colors.defaultButton,
              },
            },
            {
              props: { color: 'inherit' },
              style: {
                color: 'inherit',
              },
            },
            {
              props: { variant: 'contained' },
              style: {
                color: '#fff',
              },
            },
          ],
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { selected: true },
              style: {
                color: colors.neutralVeryDark,
                '&.Mui-selected': {
                  color: colors.neutralVeryDark,
                },
              },
            },
          ],
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '24px 24px 16px',
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: colors.neutralVeryDark,
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          justifyContent: 'space-between',
        },
        spacing: {
          padding: '8px 24px 16px',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        input: {
          height: 'auto',
        },
        underline: {
          '&.Mui-disabled:before': {
            borderBottom: `1px solid ${colors.neutral}`,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '1em',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          '&.Mui-error': {
            marginTop: '8px',
            minHeight: '1em',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          '& > li': {
            minHeight: '3em',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          minHeight: 48,
        },
      },
    },
  },
});
